import React from 'react';
import { Table } from 'antd';

const formatValue = (value, field) => {
    if (value === null || value === undefined || value === '') return '—';
    if (value === '[ĐÃ CHE]') return value;
    if (typeof value === 'boolean' || (field && field.indexOf('is_') === 0 && (value === 0 || value === 1))) {
        if (value === true || value === 1) return 'Có';
        if (value === false || value === 0) return 'Không';
    }
    if (typeof value === 'object') return Array.isArray(value) ? value.join(', ') : 'Dữ liệu chi tiết';
    return String(value);
};

const legacyChanges = (before = {}, after = {}) => {
    const keys = Array.from(new Set([...Object.keys(before || {}), ...Object.keys(after || {})]));
    return keys.filter(key => before?.[key] !== after?.[key]).map(key => ({
        field: key,
        label: key.replace(/_/g, ' '),
        old: before?.[key],
        new: after?.[key],
    }));
};

const AuditLogDiffTable = ({ before, after, changes = [] }) => {
    const rows = changes.length ? changes : legacyChanges(before, after);
    const columns = [
        {
            title: 'Thông tin',
            dataIndex: 'label',
            width: 220,
            render: text => <strong>{text || '—'}</strong>,
        },
        {
            title: 'Giá trị cũ',
            dataIndex: 'old',
            render: (_, row) => <span style={{ color: '#cf1322' }}>{formatValue(row.old_label || row.old, row.field)}</span>,
        },
        {
            title: 'Giá trị mới',
            dataIndex: 'new',
            render: (_, row) => <span style={{ color: '#389e0d' }}>{formatValue(row.new_label || row.new, row.field)}</span>,
        },
    ];

    return <Table dataSource={rows} columns={columns} pagination={false} size="small" bordered rowKey={row => row.field} locale={{ emptyText: 'Không có trường dữ liệu thay đổi' }} />;
};

export default AuditLogDiffTable;
